import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home.jsx";
import Category from "./pages/Category.jsx";
import Login from "./pages/Login.jsx";
import Register from "./pages/SignUp.jsx";
import CreatePost from "./pages/CreatePost.jsx";
import './styles/styles.css';
import Post from "./pages/Post.jsx";
import EditPost from "./pages/EditPost.jsx";
import AdminPanel from "./pages/AdminPanel.jsx";
import { SearchProvider } from "./context/SearchContext";
import { useEffect } from "react";

function AppContent() {
  const location = useLocation();
  
  // Rutas donde NO queremos mostrar el header
  const hideHeaderRoutes = ["/iniciarsesion", "/registrarse", "/crearpost"];
  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);
  
  // Ajustar padding del body dinámicamente
  useEffect(() => {
    if (shouldHideHeader) {
      document.body.classList.add('no-header');
    } else {
      document.body.classList.remove('no-header');
    }
    
    // Cleanup al desmontar
    return () => {
      document.body.classList.remove('no-header');
    };
  }, [shouldHideHeader]);
  
  return (
    <div className={shouldHideHeader ? 'app-no-header' : 'app-with-header'}>
      {!shouldHideHeader && <Header />}
      <main className={shouldHideHeader ? 'main-full-height' : 'main-with-header'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categorias" element={<Category />} />
          <Route path="/iniciarsesion" element={<Login />} />
          <Route path="/registrarse" element={<Register />} />
          <Route path="/crearpost" element={<CreatePost />} />
          <Route path="/post/:id" element={<Post />} />
          <Route path="/edit-post/:id" element={<EditPost />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </main>
      {!shouldHideHeader && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <SearchProvider> 
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </SearchProvider>
    </AuthProvider>
  );
}

export default App;
